import { ArrowLeft } from "@rsuite/icons";
import MenuIcon from "@rsuite/icons/Menu";
import { useEffect, useState } from "react";
import CloseIcon from "@rsuite/icons/Close";
import { Sidenav, Nav, Button, Modal } from "rsuite";
import { useNavigate, useParams } from "react-router-dom";

import AuthService from "../../services/auth.service";
import UserService from "../../services/user.service";
import LayoutService from "../../services/layout.service";

import Physical from "./physical/physical";
import UserMeal from "./user_meal/userMeal";
import Dashboards from "./dashboard/dashboard";
import Subscription from "./subscription/subscription";
import CalorieCounter from "./calorie_counter/calorieCounter";

import "./sidebar.scss";
import "react-toastify/dist/ReactToastify.css";

const Sidebar = (props) => {
  const [logoutModal, setLogoutModal] = useState(false);
  const { component } = props;
  const params = useParams();

  let menus = [
    {
      title: AuthService.getUser().subscription ? "وضعیت جسمی" : "وضعیت جسمی",
      element: AuthService.getUser().subscription ? Dashboards : Physical,
      key: "dashboard",
      active: true,
    },
    // {title: 'برنامه غذایی', element: AuthService.getUser().subscription, key: 'diet', active : AuthService.getUser().subscription === null ? false : true},
    {
      title: "ابزارهای سلامت",
      element: CalorieCounter,
      key: "calorie-counter",
      active: true,
    },
    {
      title: "رژیم های خریداری شده",
      element: Subscription,
      key: "subscriptions",
      active: true,
    },
    { title: "صفحه اصلی سایت", key: "changaal", active: true },
    { title: "قوانین", key: "tos", active: true },
    // {title: 'دانلود فایل' , key:'pdf' , active :  AuthService.getUser().subscription === null ? false : true},
    { title: "خروج از حساب کاربری", active: true },
  ];

  menus = menus.filter(function (menu) {
    return menu.active !== false;
  });

  const componentIndex = menus.findIndex(
    (menu) => menu.key === component && menu.key !== undefined
  );
  const [activeKey, setActiveKey] = useState(
    componentIndex >= 0 ? componentIndex : 0
  );
  const [sidebarStatus, setSidebarStatus] = useState(false);
  const { setContent } = props;

  const navigate = useNavigate();
  const user = AuthService.getUser();
  const currentUser = AuthService.getCurrentUser()?.user;
  const isForeign = currentUser?.is_foreign;

  useEffect(() => {
    if (componentIndex >= 0) {
      onMenuItemClick(componentIndex);
    }

    if (componentIndex < 0 && component === "active-subscription") {
      const { subscription } = user;
      if (subscription) {
        const periodIndex = subscription.current_period_number - 1;
        setContent(
          <UserMeal subscriptionId={subscription.id} periodId={periodIndex} />
        );
      }
    }

    if (componentIndex < 0 && component === "user-meal") {
      setActiveKey(2);
      setContent(
        <UserMeal
          subscriptionId={params.subscriptionId}
          periodId={params.periodId}
        />
      );
    }
  }, []);

  return (
    <div className="max-w-[30%]">
      <div className="mobile-sidebar-toggle">
        <div className="mobile-sidebar-name">
          {`${currentUser?.name ? currentUser?.name : ""} ${
            currentUser?.surname ? currentUser?.surname : ""
          }`}
        </div>
        <div onClick={(e) => setSidebarStatus(true)} className="menu-icon">
          <MenuIcon />
        </div>
      </div>
      <div className={`sidebar ${sidebarStatus ? "opened" : ""}`}>
        <div
          className="sidebar-toggle"
          onClick={(e) => setSidebarStatus(false)}
        >
          <CloseIcon />
        </div>
        <div className="user-profile">
          <div className="user-image">
            <img src={user?.user?.avatar} alt="" />
          </div>
          <div className="user-title mt-1">
            {currentUser?.name}
            <div style={{ fontWeight: "normal", fontSize: ".75rem" }}>
              {isForeign ? currentUser?.mobile + "+" : currentUser?.mobile}
            </div>
            <div
              style={{ fontWeight: "normal", fontSize: ".75rem" }}
              dir="ltr"
              className="truncate max-w-[233px]"
            >
              {`${currentUser?.email ? currentUser?.email : ""}`}
            </div>
          </div>
          {!AuthService.getUser().subscription &&
          !AuthService.getUser().reserved ? (
            <Button
              appearance="primary"
              onClick={(e) => navigate("/subscription-packages")}
              block
            >
              دریافت برنامه
            </Button>
          ) : !AuthService.getUser().reserved &&
            AuthService.getUser().subscription.days < 3 ? (
            <Button
              appearance="primary"
              onClick={(e) => navigate("/subscription-packages")}
              block
            >
              رزرو دوره بعدی
            </Button>
          ) : (
            ""
          )}
        </div>
        <Sidenav>
          <Sidenav.Body>
            <Nav activeKey={activeKey}>
              {menus.map((menu, menuIndex) => {
                return (
                  <Nav.Item
                    className="sidebar-menu-item"
                    key={menuIndex}
                    eventKey={menuIndex}
                    onClick={(e) => onMenuItemClick(menuIndex)}
                    icon={<ArrowLeft />}
                  >
                    {menu.title}
                  </Nav.Item>
                );
              })}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>

      {!isForeign && (
        <a
          className="hidden lg:block"
          href={LayoutService.getBanners()[0]?.data.desktop.value}
        >
          <img
            src={LayoutService.getBanners()[0]?.image.original}
            alt=""
            className="max-w-[280px] mt-4"
          />
        </a>
      )}
      <Modal
        open={logoutModal}
        onClose={closeLogoutModal}
        size="xs"
        keyboard={true}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mt-1-5 tac">
            آیا برای خروج از حساب کاربری اطمینان دارید؟
          </p>
        </Modal.Body>
        <Modal.Footer style={{ textAlign: "center" }}>
          <div className="modal_buttons_container">
            <button
              onClick={closeLogoutModal}
              className="btn-green-secondary"
              style={{ width: "45%" }}
            >
              خیر
            </button>
            <button
              onClick={logout}
              className="btn-green"
              style={{ width: "45%" }}
            >
              بله
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );

  async function onMenuItemClick(menuIndex) {
    if (menuIndex === menus.length - 1) {
      openLogoutModal();
      return true;
    }

    setActiveKey(menuIndex);

    const menu = menus[menuIndex];

    if (menu.key === "diet") {
      return true;
    }

    if (menu.key === "changaal") {
      window.location.href = `${
        process.env.NEXT_APP_URL ?? "https://changaal.com"
      }`;
      return true;
    }
    if (menu.key === "calorie-counter" && window.innerWidth < 763) {
      window.location.href = "https://tools.changaal.com/";
      return true;
    }

    if (menu.key === "pdf") {
      let pdfStream = await UserService.getPdfFile();
      const blob = new Blob([pdfStream.data], { type: "application/pdf" });
      //window.open(URL.createObjectURL(blob));
      let pdfURL = window.URL.createObjectURL(blob);
      let tempLink = document.createElement("a");
      tempLink.href = pdfURL;
      tempLink.setAttribute("download", "help.pdf");
      tempLink.click();
      return true;
    }

    if (menu.key === "tos") {
      window.location.href = `${
        process.env.NEXT_APP_URL ?? "https://changaal.com"
      }/pages/rules`;
      return true;
    }

    const Element = menu.element;
    setSidebarStatus(false);
    setContent(<Element setContent={setContent} />);
    window.history.pushState({ urlPath: `/${menu.key}` }, "", `/${menu.key}`);
  }

  function openLogoutModal() {
    setLogoutModal(true);
  }

  function logout() {
    localStorage.removeItem("error");
    localStorage.removeItem("user");
    localStorage.removeItem("installed");
    window.location.replace(
      `${process.env.NEXT_APP_URL ?? "https://changaal.com"}`
    );
  }
  function closeLogoutModal() {
    setLogoutModal(false);
  }
};

export default Sidebar;
